import type { CalendarComposeInitializationConfig } from 'owa-calendar-helpers-types/lib/CalendarComposeInitializationConfig';
import { createComposeFormId } from '../utils/createComposeFormId';
import addTab from 'owa-tab-store/lib/utils/addTab';
import { TabType } from 'owa-tab-store';
import { addPopoutV2 } from 'owa-popout-v2';
import { isFluidEnabledForSource, FluidOwaSource } from 'owa-fluid-validations';
import { FullComposeFormViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { lazyModule, lazyShowFullComposeToEdit } from 'owa-calendar-compose-form-store';
import {
    getOpenCalendarFullComposeActionType,
    tryStartFullComposePerfDatapoint,
    OpenCalendarFullComposeActionType,
} from 'owa-calendar-compose-form-utils';

const CALENDAR_POPOUT_WINDOW_SIZE = {
    width: 1095,
    height: 640,
};

export async function openCalendarFullCompose(
    config: CalendarComposeInitializationConfig
): Promise<string | null> {
    const formId = createComposeFormId();

    const actionType = getOpenCalendarFullComposeActionType(config.viewType);

    await tryStartFullComposePerfDatapoint(
        actionType,
        formId!,
        lazyModule.getIsLoaded() /* bundleAlreadyLoaded */,
        config.fullComposeEntrySource
    );

    runformOpenAction(actionType, formId, config);

    return formId;
}

function runformOpenAction(
    actionType: OpenCalendarFullComposeActionType,
    formId: string,
    config: CalendarComposeInitializationConfig
) {
    switch (actionType) {
        case OpenCalendarFullComposeActionType.DeeplinkInSameWindow:
            openDeeplinkInSameWindow(formId, config);
            return;
        case OpenCalendarFullComposeActionType.Modal:
            openModal(formId, config);
            return;
        case OpenCalendarFullComposeActionType.ProjectionPopout:
            openProjectionPopout(formId, config);
            return;
        case OpenCalendarFullComposeActionType.DeeplinkPopout:
            openDeeplinkPopout(config);
            return;
    }
}

function initializeCompose(
    formId: string,
    config: CalendarComposeInitializationConfig,
    viewType: FullComposeFormViewType
) {
    config.viewType = viewType;
    lazyShowFullComposeToEdit.importAndExecute(formId, config);
}

function openDeeplinkInSameWindow(formId: string, config: CalendarComposeInitializationConfig) {
    initializeCompose(formId, config, FullComposeFormViewType.DeeplinkPopOut);
}

function openModal(formId: string, config: CalendarComposeInitializationConfig) {
    initializeCompose(formId, config, FullComposeFormViewType.Modal);
}

function openProjectionPopout(formId: string, config: CalendarComposeInitializationConfig) {
    const tabId = addTab(
        TabType.CalendarCompose,
        false /* isShown */,
        false /* makeActive */,
        formId
    );

    addPopoutV2(
        'calendar',
        'compose',
        {
            projectionTabId: tabId,
        },
        CALENDAR_POPOUT_WINDOW_SIZE
    );

    initializeCompose(formId, config, FullComposeFormViewType.ProjectionPopOut);
}

function openDeeplinkPopout(config: CalendarComposeInitializationConfig) {
    addPopoutV2(
        'calendar',
        'compose',
        {
            composeConfig: config,
            includeFluidOnPopout: isFluidEnabledForSource(FluidOwaSource.CalendarCompose),
        },
        CALENDAR_POPOUT_WINDOW_SIZE
    );
}
